import Model from "./base/model";

class User extends Model{
  resourceName() {
    return "users";
  }

  fields() {
    return {
      name: "",
      email: "",
      password: "",
      company_id: "",
      department: "",
      cellphone: "",
      is_responsible: "",
      company:"",
      role: "",
      permissions:"",
      verification_code:"",
      verification_code_created_at:"",
      need_refresh_app: "",
      type: "",
      exist: "",
      code: "",
      prospector_logo: "",
      receive_notification: "",
      onboarding: "",
      accepted_use_terms: "",
      accepted_psi: "",
      use_terms_file_id: "",
    };
  }
  async findMe(){
    return this.request(
      this.resourceName() + "/me?include=company,company.address",
      "GET"
    );
  }
  async updateMe(data){
    return this.request(
      this.resourceName() + "/me/update",
      "PATCH",
      {},
      data
    );
  }
  async createWithoutToken(data){
    return this.request(
      this.resourceName() + "_finance",
      "POST",
      {},
      data
    );
  }
  async tmsRegister(data){
    return this.request(
      "tms_register",
      "POST",
      {},
      data
    )
  }

  async resendVerifyEmail(data){
    return this.request(
      "resend_verify_email",
      "POST",
      {},
      data
    )
  }

  async sendInsertPassword(data){
    return this.request(
      "send_insert_password",
      "POST",
      {},
      data
    )
  }
}


export default new User();
